
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class GiftVoucherSalesReceiptGrid extends Serenity.EntityGrid<GiftVoucherSalesReceiptRow, any> {
        protected getColumnsKey() { return 'Retail.GiftVoucherSalesReceipt'; }
        protected getDialogType() { return GiftVoucherSalesReceiptDialog; }
        protected getIdProperty() { return GiftVoucherSalesReceiptRow.idProperty; }
        protected getInsertPermission() { return GiftVoucherSalesReceiptRow.insertPermission; }
        protected getLocalTextPrefix() { return GiftVoucherSalesReceiptRow.localTextPrefix; }
        protected getService() { return GiftVoucherSalesReceiptService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}